import React from "react"
import "./pageHeader.scss"

interface Props {
  label: string
  title: string
  subtitle?: string
}

const PageHeader: React.FC<Props> = ({ label, title, subtitle }) => (
  <div className="page-header">
    <div className="page-header__bg" />
    <div className="page-header__overlay" />
    <div className="container">
      <span className="page-header__label">{label}</span>
      <h1 className="page-header__title">{title}</h1>
      {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
      <span className="page-header__rule" />
    </div>
  </div>
)

export default PageHeader
